import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'initials',
  standalone: true, // Optional: if you're using standalone components
})
export class InitialsPipe implements PipeTransform {
  transform(
    user: { firstName?: string; lastName?: string } | null | undefined
  ): string {
    if (!user) return '';

    const { firstName = '', lastName = '' } = user;
    const firstInitial = firstName[0] ?? '';
    const lastInitial = lastName[0] ?? '';

    return `${firstInitial}${lastInitial}`.toUpperCase();
  }
}
